export interface State {
    productAddSuccess: boolean;
}

const state = (): State => ({
    productAddSuccess: false,
})

export default state